export default __webpack_public_path__ + "static/media/classic.653a10fe.jpg";